import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorService } from 'src/app/error.service';
import { LocationBO } from './location.modal';

@Injectable({
  providedIn: 'root'
})
export class LocationService {

  constructor(private http: HttpClient, public errorService: ErrorService) { }


  SaveorUpdateLocation(saveLocationList: LocationBO): Observable<any> {
    let url = "api/Location/SaveLocation";
    return this.http.post(url, saveLocationList, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  DeleteLocation(locationId: any): Observable<any> {
    let url = "api/Location/DeleteLocation/" + locationId;
    return this.http.delete(url, { observe: 'response', responseType: "text" },).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }

  GetLovDropdown(paramsData: URLSearchParams): Observable<[{ Key: string, Value: string }]> {
    let url = "api/Lov/getLovDropDown?";
    return this.http.get<[{ Key: string, Value: string }]>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
  //==============================get employee permission==========================================//
  getpermission(paramsData: URLSearchParams): Observable<any> {
    let url = "api/FunctionPermission/getfunctionpermissionemployee?";
    return this.http.get<any>(url + paramsData, { observe: 'response' }).pipe(
      map(data => data.body),
      catchError(this.errorService.handleError)
    )
  }
}
